var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    !_vm.filterTypeNearby
      ? _c("h2", { staticClass: "filter-title" }, [
          _vm._v(
            "\n    " +
              _vm._s(_vm.$t("10000236.Home_TitlePopularDeals")) +
              "\n  "
          ),
        ])
      : _vm._e(),
    _vm._v(" "),
    _c(
      "div",
      {
        staticClass: "open-filter-button-container",
        class: { "mobile-spacing": _vm.filterTypeNearby },
      },
      [
        !_vm.filterTypeNearby && _vm.hasCityName
          ? _c(
              "button",
              {
                staticClass: "city-select-button",
                on: { click: _vm.triggerSuperDropdown },
              },
              [
                _c("i", {
                  staticClass: "sd2-icons pointer city-select-button-icon",
                }),
                _vm._v(" "),
                _c("span", { staticClass: "city-select-button-text" }, [
                  _vm._v(
                    _vm._s(_vm.$t("10009989.Home_LabelForLocation")) +
                      " " +
                      _vm._s(_vm.cityName)
                  ),
                ]),
                _vm._v(" "),
                _c("i", {
                  staticClass:
                    "sd2-icons arrow-down-big city-select-button-arrow",
                }),
              ]
            )
          : _vm._e(),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "sorting-container" },
          [
            _c(
              "button",
              {
                staticClass: "open-filter-button sorting",
                class: { active: _vm.isSortDropdownOpen },
                attrs: { disabled: _vm.sortOptions.length === 0 },
                on: { click: _vm.handleSortClick },
              },
              [
                _c("i", { staticClass: "sd2-icons sort" }),
                _vm._v(" "),
                _c("div", { staticClass: "open-filter-button-text" }, [
                  _vm._v(
                    "\n          " +
                      _vm._s(_vm.$t("36081.App_FilterSortByFilter")) +
                      ":\n          "
                  ),
                  _c("span", { staticClass: "sorting-type" }, [
                    _vm._v(_vm._s(_vm.defaultSortingType)),
                  ]),
                ]),
              ]
            ),
            _vm._v(" "),
            _vm.sortOptions.length > 0 && _vm.isSortDropdownOpen
              ? _c("SortDropdown", {
                  attrs: {
                    "sort-options": _vm.sortOptions,
                    "selected-sort": _vm.selectedSort,
                  },
                  on: { "sort-list-item-click": _vm.handleSortChange },
                })
              : _vm._e(),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "button",
          {
            staticClass: "open-filter-button",
            on: {
              click: function ($event) {
                return _vm.$emit("on-filter-button-click")
              },
            },
          },
          [
            _c("i", {
              staticClass: "sd2-icons filter-outline open-filter-button-icon",
            }),
            _vm._v(" "),
            _c("span", { staticClass: "open-filter-button-text" }, [
              _vm._v(_vm._s(_vm.$t("36078.App_FilterHomeLabelButton"))),
            ]),
            _vm._v(" "),
            _vm.badge && _vm.showBadge
              ? _c(
                  "span",
                  {
                    staticClass: "open-filter-button-count",
                    style: { background: _vm.badge.color },
                    attrs: { id: "filter-button-badge" },
                  },
                  [_vm._v("\n        " + _vm._s(_vm.badge.label) + "\n      ")]
                )
              : _vm._e(),
          ]
        ),
      ]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }